<div 
    [@fadeIn] 
    [innerHTML]="customHtmlContent" 
    (mouseenter)="notifyMouseEnter($event)" 
    (mouseleave)="notifyMouseLeave($event)" 
    class="branding--product-info-popup"
    >
</div>
